import React, { useEffect } from "react";
import { Box, Button, Divider, Text, VStack } from "@chakra-ui/react";
import { useFormikContext } from "formik";
import { TextField } from "../fields/TextField/TextField";
import { SwitchField } from "../fields/SwitchField/SwitchField";
import DateUtil from "../../util/DateUtil";

interface OffboardingFormValues {
  digitalMembershipConfiguration?: {
    ExpireAllDmcAfterDate?: string | null;
    ObfuscateMemberValues?: boolean;
  };
}

export const BusinessDigitalMembershipOffboardingSection = () => {
  const { values, setFieldValue } = useFormikContext<OffboardingFormValues>();

  const expireAllDmcAfterDate =
    values.digitalMembershipConfiguration?.ExpireAllDmcAfterDate;
  const hasExpireDate =
    !!expireAllDmcAfterDate && expireAllDmcAfterDate.trim() !== "";

  useEffect(() => {
    if (
      !hasExpireDate &&
      values.digitalMembershipConfiguration?.ObfuscateMemberValues
    ) {
      setFieldValue(
        "digitalMembershipConfiguration.ObfuscateMemberValues",
        false
      );
    }
  }, [
    hasExpireDate,
    setFieldValue,
    values.digitalMembershipConfiguration?.ObfuscateMemberValues,
  ]);

  const clearExpireAllDmcAfterDate = () => {
    setFieldValue("digitalMembershipConfiguration.ExpireAllDmcAfterDate", "");
    setFieldValue(
      "digitalMembershipConfiguration.ObfuscateMemberValues",
      false
    );
  };

  return (
    <Box
      w="100%"
      p={4}
      border="1px solid"
      borderColor="cherryUi.600"
      borderRadius="md"
    >
      <Text fontSize="sm" color="cherryUi.600" fontWeight="bold">
        DANGER
      </Text>
      <Divider mb={2} borderColor="cherryUi.600" />
      <VStack w="100%" spacing={4} alignItems="flex-start">
        <TextField
          horizontal
          valueProps={{ flex: 2 }}
          label="Expire All DMC After Date (UTC)"
          name="digitalMembershipConfiguration.ExpireAllDmcAfterDate"
          type="datetime-local"
          min={DateUtil.getUtcNowDateTimeLocal()}
          infoText="Clearing the date disables the kill switch. When set, DMC passes expire on the next pass rebuild, unless a more specific expiry already applies. You currently need to schedule a silent push update to force existing passes to expire, on or after this date. Take care with time zones."
          labelRightElement={
            <Button
              size="xs"
              variant="ghost"
              color="cherryUi.600"
              isDisabled={!hasExpireDate}
              onClick={clearExpireAllDmcAfterDate}
            >
              Clear
            </Button>
          }
        />
        <SwitchField
          horizontal
          valueProps={{ flex: 2 }}
          label="Obfuscate Member Values"
          name="digitalMembershipConfiguration.ObfuscateMemberValues"
          colorScheme="cherryButton"
          isDisabled={!hasExpireDate}
          infoText="Only applies when 'Expire All DMC After Date' is set.  ON: Pass expires. Member values are obfuscated, QR code and NFC data is cleared, and real member photo is not shown.  OFF: Pass expires, but is otherwise unchanged."
        />
      </VStack>
    </Box>
  );
};
